import { render, staticRenderFns } from "./IndexTableHead.vue?vue&type=template&id=267d551a"
import script from "./IndexTableHead.vue?vue&type=script&lang=js"
export * from "./IndexTableHead.vue?vue&type=script&lang=js"
import style0 from "./IndexTableHead.vue?vue&type=style&index=0&id=267d551a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports